import React from "react";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
// import ConfirmationModal from "./ConfirmationModal";

export default function NotesLPMModalThreeSixtyDegreeView(props) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
			className="conv-mt40"
		>
			<ModalContent>
			<div className="p-2 modal-headers-bar">
					<span>Notes</span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={() => props.toggleModal(!props.isOpen)}
					>
						<X
							style={{ pointerEvents: "none" }}
							color="white"
						/>
					</button>
				</div>
				<div className="m-3">
					{" "}
					{/* <div className="notesHistory">{renderNotesTrail()}</div> */}
					<div className="mt-2">
						<label>Followup Actions</label>
						<div>
							<textarea
								name="sFollowupNotes"
								className="w-100 form-control rounded"
								value={props.notesDetails.sFollowupNotes}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
					</div>
					<div className="mt-2">
						<label>Follow up on</label><br></br>
						<ReactDatePicker
							dateFormat="dd/MM/yyyy"
							selected={
								props.notesDetails.dtFollowupOn
									? new Date(props.notesDetails.dtFollowupOn)
									: null
							}
							onChange={(date) =>
								props.onInputChange("dtFollowupOn", date)
							}
							minDate={new Date()}
						/>
					</div>
					<div className="mt-2">
						<label>
							Notes <span className="required">*</span>
						</label>
						<div>
							<textarea
								className="w-100 form-control rounded"
								name="sNotes"
								value={props.notesDetails.sNotes}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
					</div>
					<div className="mt-4 flex">
						<div>
							<Button onClick={props.onSaveNotesDetails}>
								Save
							</Button>
							<span
								className="ml-2 cursor-pointer"
								onClick={props.toggleModal}
							>
								Cancel
							</span>
						</div>
					</div>
				</div>
				{/* <ConfirmationModal
					message="Closing the modal will discard your changes. Continue?"
					isOpen={props.isOpenConfirmationModal}
					toggleModal={props.toggleConfirmationModal}
					changeState={props.confirmChangeNotes}
				/> */}
			</ModalContent>
		</Modal>
	);
}
